<template>
  <div class="thank-you">
    <div class="thank-you__circle" ref="circle">
      <svg class="thank-you__check" width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path ref="checkPath" d="M20 6L9 17l-5-5" />
      </svg>
    </div>
    <div class="thank-you__badge" ref="badge">{{ $t('thankYou.badge') }}</div>
    <h2 class="thank-you__title" ref="title">{{ $t('thankYou.title') }}</h2>
    <p class="thank-you__subtitle" ref="subtitle">{{ $t('thankYou.subtitle') }}</p>
    <div class="thank-you__particles" ref="particles">
      <span v-for="i in 12" :key="i" class="thank-you__particle" />
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  name: 'ThankYou',
  mounted() {
    this.playAnimation()
  },
  methods: {
    playAnimation() {
      const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

      tl.fromTo(this.$refs.circle,
        { scale: 0, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.5 }
      )
      .fromTo(this.$refs.checkPath,
        { strokeDasharray: 30, strokeDashoffset: 30 },
        { strokeDashoffset: 0, duration: 0.4 },
        '-=0.1'
      )
      .fromTo(this.$refs.badge,
        { y: 10, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.3 },
        '-=0.1'
      )
      .fromTo(this.$refs.title,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.4 },
        '-=0.15'
      )
      .fromTo(this.$refs.subtitle,
        { y: 20, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.4 },
        '-=0.2'
      )

      // Particle burst
      this.$nextTick(() => {
        const particles = this.$refs.particles?.children
        if (!particles) return
        Array.from(particles).forEach((p, i) => {
          const angle = (i / 12) * Math.PI * 2
          const dist = 60 + Math.random() * 40
          gsap.fromTo(p,
            { x: 0, y: 0, scale: 1, opacity: 1 },
            {
              x: Math.cos(angle) * dist,
              y: Math.sin(angle) * dist,
              scale: 0,
              opacity: 0,
              duration: 0.8,
              delay: 0.4 + Math.random() * 0.2,
              ease: 'power2.out',
            }
          )
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.thank-you {
  text-align: center;
  padding: 2rem 0;
  position: relative;

  &__circle {
    width: 96px;
    height: 96px;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(40, 199, 111, 0.15), rgba(40, 199, 111, 0.05));
    border: 2px solid rgba(40, 199, 111, 0.25);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1.5rem;
    color: #28c76f;
  }

  &__badge {
    display: inline-block;
    padding: 5px 16px;
    border-radius: 16px;
    background: rgba(40, 199, 111, 0.1);
    color: #28c76f;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    margin-bottom: 1.5rem;
    border: 1px solid rgba(40, 199, 111, 0.15);
  }

  &__title {
    font-size: clamp(1.5rem, 4vw, 2.2rem);
    font-weight: 800;
    margin-bottom: 0.75rem;
    background: linear-gradient(135deg, #fff 30%, var(--gold-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__subtitle {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.45);
    max-width: 420px;
    margin: 0 auto;
    line-height: 1.6;
  }

  &__particles {
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;
  }

  &__particle {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--gold);

    &:nth-child(even) { background: #28c76f; width: 5px; height: 5px; }
    &:nth-child(3n) { background: var(--accent); width: 4px; height: 4px; }
  }
}
</style>
